module.exports = __webpack_public_path__ + "img/marketing.db358644.png";